import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Data2Service } from '../../common/data2.service';

@Component({
	selector: 'app-leads-history',
	templateUrl: './leads-history.component.html',
	styleUrls: ['./leads-history.component.css'],
})
export class LeadsHistoryComponent implements OnInit {
	private itemsBeforeDataLoad = 1;
	private readonly leadId = this.route.snapshot.params['id'];
	private users;
	loader = false;
	history;

	constructor(
		private readonly api: Data2Service,
		private readonly route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.api.get('/users/', (result, error) => {
			this.loader = true;
			this.users = result.data;
			this.loadData();
		});
	}

	loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.loader = true;
		this.api.get('/leadsHistory/' + this.leadId + '/', (result, error) => {
			result.data.forEach((obj) => {
				const user = this.users.find((objFind) => objFind.id == obj.user);
				obj.user = user ? user.name : '?';
			});
			this.history = result.data;
			this.loader = false;
		});
	}
}
